import {
  DOMAIN_ERROR_CODES,
  DomainErrorCodeSchema,
  type DomainErrorCode,
} from "@repo/domain-events";
import { ExecutionEngineClientError } from "@repo/execution-engine-client";

export const getExecutionDomainErrorCode = (
  error: unknown,
): DomainErrorCode => {
  if (!(error instanceof ExecutionEngineClientError)) {
    return DOMAIN_ERROR_CODES.executionUnknown;
  }

  const parsed = DomainErrorCodeSchema.safeParse(error.details?.error);
  return parsed.success ? parsed.data : DOMAIN_ERROR_CODES.executionUnknown;
};
